export const TM_MCP_SERVER_NAME = 'tm';
export const TM_MCP_SEARCH_BY_KEYWORDS_TOOL_NAME = 'search_candidates_by_keywords';
export const TM_MCP_SEARCH_SEMANTICALLY_TOOL_NAME = 'search_candidates_semantically';
export const TM_MCP_RESEARCH_JOB_TITLES_TOOL_NAME = 'research_job_titles';
export const TM_MCP_RESEARCH_COMPETITOR_COMPANIES_TOOL_NAME = 'research_competitor_companies';
